export var VERSION = '1.14.2';
//# sourceMappingURL=version.js.map